import React from 'react';
import Layout from '../../components/Layout';
import messages from '../../locale/messages';
import Contact from './Contact';
import { getSpecificConfig } from '../../helpers/getConfigValue';

const title = 'Contact Us';

export default async function action({ intl }) {

  const title = intl?.formatMessage(messages.contactForm);

  const reCaptcha = await getSpecificConfig({ name: ['reCaptchaStatus'] });

  return {
    title,
    component: <Layout><Contact title={title} reCaptcha={reCaptcha} /></Layout>,
  };
}
